import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/service/language-service/language.service';

type Filters = {
  id?: number; // Opcional
  name: string;
  code: string;
  checked: boolean;
};


@Component({
  selector: 'app-filtro-toogle',
  templateUrl: './filtro-toogle.component.html',
  styleUrls: ['./filtro-toogle.component.scss'],
})
export class FiltroToogleComponent  implements OnInit {
  @Input() filterActive:boolean = false;
  @Input() applyOnlyOneFilter:boolean = false;
  @Input() filters:Filters[];
  filterSelected = [];

  @Output() filterBy: EventEmitter<any> = new EventEmitter<any>();
  language:string = "es";

  constructor(private languageService: LanguageService,) { }

  ngOnInit() {this.subLanguageConfig();}

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  filter() {
    this.filterSelected = [];
		this.filters.forEach(element => {
			if(element.checked){
				this.filterSelected.push(element.code)
			}
		});
    // console.log("aplicar: ",this.filterSelected);
    this.filterBy.emit(this.filterSelected);
  }

  setOnlyOneFilter(index) {
    this.filters.forEach((option, i) => {
      option.checked = i === index ? !option.checked : false;
    });
  }


}
